var Curriculog = Curriculog || {};
Curriculog.util = (function (util, $, _) {
	/**
	 * A Column that needs to be stretched.
	 * @param {[type]} jquerySelector [description]
	 */
	var Column = function (jquerySelector) {
		this.$el = $(jquerySelector);
    if (this.$el.length > 0) {
      this.height = this.$el.css('height', 'auto').outerHeight();
  		this.bottom = this.$el.offset().top + this.height;
    } else {
      this.height = 0;
      this.bottom = 0;
    }
	};

	/**
	 * Adjust this columns height so that the bottom is equal to `bottomPosition`.
	 * @param  {Number} bottomPosition
	 */
	Column.prototype.stretch = function (bottomPosition) {
		var difference = bottomPosition - this.bottom;
		var newHeight = this.height + difference;
		if (this.bottom < bottomPosition) {
			this.$el.css('height', newHeight);
		} 
	};


	/**
	 * Container of columns that need their heights equalized.
	 * @param {Array(String)} columnSelectors -- array of jquery selectors.
	 * @param {Number} minHeight -- will be uses as the max height if all 
	 *                           the columns are shorter than minHeight.
	 */
	var Columns = function (columnSelectors, minHeight) {
		this.columns = _.map(columnSelectors, function (selector) {
			return new Column(selector);
		});
		this.minHeight = minHeight;
	};
	
	/**
	 * Get the column with the greatest bottom position.
	 * @return {Number}
	 */
	Columns.prototype.getTallest = function () {
		var bottoms = _.pluck(this.columns, 'bottom');
		bottoms.push(this.minHeight)
		return Math.max.apply(null, bottoms);
	};
	
	/**
	 * Call the stretch method for each column passing in the tallest column.
	 */
	Columns.prototype.equalizeHeights = function () {
		_.invoke(this.columns, 'stretch', this.getTallest());
	};


	/**
	 * Makes all columns have an equal bottom position.
	 * @param  {Array(String)} columnSelectors -- jquery selectors of columns.
	 */
	util.stretch = function (columnSelectors) {
		// Use the objects obove to equalize the column height.
		var minHeight = 1000;
		var columns = new Columns(columnSelectors, minHeight);
		columns.equalizeHeights(minHeight);
	}
	
	return util;
}(Curriculog.util || {}, jQuery, _));
